import styled from "styled-components";
import { Whatsapp } from "@styled-icons/bootstrap/Whatsapp";

const Button = styled.a`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
  padding: 5px 10px;
  width: 180px;
  border-radius: 5px;
  font-weight: 600;
  border: 1px solid var(--secondary-4);
  color: var(--secondary-4);
`;

const WhatsappIcon = styled(Whatsapp)`
  height: 20px;
  margin-top: -3px;
  color: var(--secondary-4);
`;

function WhatsappButton() {
  return (
    <Button href="http://wa.me/972584475824">
      <WhatsappIcon />
      לכתיבה לחצו כאן
    </Button>
  );
}

export default WhatsappButton;
